module.exports = __webpack_public_path__ + "static/media/Auto-Promo.964d947e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Auto-Promo.jpg
// module id = 123
// module chunks = 0